(function(angular, module) {var nodeChildDirective;

nodeChildDirective = function() {
  return {
    restrict: 'E',
    templateUrl: 'util/tags/nodeChild',
    scope: {
      node: '=node'
    },
    require: '^dybTagPicker',
    link: function(scope, element, attrs, tagpicker) {
      if (scope.node.slug != null) {
        element.addClass('tag-' + scope.node.slug);
      }
      element.on('click', function() {
        scope.$apply(scope.node.browse);
      });
      element.on('mouseenter', function() {
        tagpicker.hoverItem(scope.node);
      });
      scope.$on('tagpicker:activeItemChanged', function(event, item) {
        element.toggleClass('active', item === scope.node);
      });
    }
  };
};

module.directive('dybTagpickerNodeChild', nodeChildDirective);
})(angular, angular.module("dybTags"));